var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"variant":"link","no-caret":""}},[_c('span',{attrs:{"slot":"button-content"},slot:"button-content"},[_vm._v("Menu")]),_vm._v(" "),_vm._l((_vm.menus),function(item){return _c('b-dropdown-item',{key:item.name,attrs:{"to":{name: 'geo-'+item.name}}},[_vm._v("\n    "+_vm._s(item.desc)+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ada20a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/MGeoZipMenu.vue
// module id = null
// module chunks = 